'use strict';

module.exports = require('react/lib/ReactDOM');



/*****************
 ** WEBPACK FOOTER
 ** /usr/src/sentry/~/react-dom/index.js
 ** module id = 20
 ** module chunks = 0
 **/